class DropDown {
  constructor() {
    // this.dropDowns = document.querySelectorAll(".dropdown");
    this.dropDownTogglers = document.querySelectorAll(".dropdown-toggler");
    this.articles = document.querySelectorAll(".toogleByClick");
    this.initListeners();
  }

  handleTogglerClick = ({ currentTarget }, byButton = false) => {
    const dropDown = currentTarget.parentNode.querySelector(".dropdown");

    byButton ? currentTarget.classList.toggle("open-dropdown") : currentTarget.nextElementSibling.classList.toggle("open-dropdown");

    if (this.isDropDownOpen(dropDown)) {
      dropDown.classList.remove("open");
    } else {
      dropDown.classList.add("open");
    }
  };

  isDropDownOpen = (dropdown) => {
    if (dropdown.classList.contains("open")) return true;

    return false;
  };

  initListeners = () => {
    this.dropDownTogglers.forEach((button) => {
      button.addEventListener("click", (event) => {
        this.handleTogglerClick(event, true);
      });
    });

    this.articles.forEach((article) => {
      article.addEventListener("click", (event) => {
        this.handleTogglerClick(event, false);
      });
    });
  };
}

export default DropDown;
